import { mapEnumToOptions } from '@unistocks/shared/utils/enum-utils';

// Defined in api but not exposed in any dto
export enum AssetListLayout {
  PercentageChange = 1,
  NominalChange = 2,
  CurrentPrice = 4
}

export const assetListLayoutOptions = mapEnumToOptions(AssetListLayout, 'AssetListLayout');
